var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_5634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.32739 3.99512V7.99067",
    stroke: "#D1D5DC",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98889 3.99512V7.99067",
    stroke: "#D1D5DC",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33185 7.99121H14.384",
    stroke: "#D1D5DC",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9866 11.9862H13.9844C13.9844 11.9862 14.3174 10.8541 14.5172 10.1216C14.5838 9.85526 14.6503 9.58889 14.6503 9.32252C14.6503 9.05615 14.5838 8.78978 14.5172 8.52341L13.5849 5.19378C13.3851 4.52786 12.7192 3.99512 11.9866 3.99512H2.6637C2.31047 3.99512 1.97171 4.13544 1.72194 4.38521C1.47217 4.63498 1.33185 4.97374 1.33185 5.32697V11.9862H3.32962",
    stroke: "#D1D5DC",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6615 13.319C5.39706 13.319 5.99335 12.7227 5.99335 11.9871C5.99335 11.2516 5.39706 10.6553 4.6615 10.6553C3.92594 10.6553 3.32965 11.2516 3.32965 11.9871C3.32965 12.7227 3.92594 13.319 4.6615 13.319Z",
    stroke: "#D1D5DC",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99335 11.9863H9.32297",
    stroke: "#D1D5DC",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6548 13.319C11.3903 13.319 11.9866 12.7227 11.9866 11.9871C11.9866 11.2516 11.3903 10.6553 10.6548 10.6553C9.91923 10.6553 9.32294 11.2516 9.32294 11.9871C9.32294 12.7227 9.91923 13.319 10.6548 13.319Z",
    stroke: "#D1D5DC",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_5634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9822,
    height: 15.9822,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.fe62e2d6832cc851e78a8afbb8e21313.svg";
export { ForwardRef as ReactComponent };